import React, { useCallback, useMemo } from 'react';
import { Button, T } from '@colonist/ui';
import { Table } from '@colonist/ui-platform';
import styles from '../FriendRequestTableShared/FriendRequestTableShared.module.scss';
const IncomingFriendRequestActionsCell = ({ userId, username, onAccept, onDecline })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.actionButtons,
        onClick: (event)=>event.stopPropagation()
    }, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "profile-friend-request-accept-button",
        variant: "primary",
        size: "sm",
        onClick: ()=>onAccept(userId, username)
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:colonistCommon.buttons.accept'
        }
    })), /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "profile-friend-request-decline-button",
        variant: "danger",
        size: "sm",
        onClick: ()=>onDecline(userId, username)
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:colonistCommon.buttons.decline'
        }
    })));
export const IncomingFriendRequestTable = ({ requests, onUserClick, onAccept, onDecline })=>{
    const columns = useMemo(()=>[
            {
                id: 'username',
                overflow: 'truncate',
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.friends.tableHeaders.player'
                        }
                    }),
                cell: ({ value: username, row })=>/*#__PURE__*/ React.createElement("div", {
                        className: styles.row
                    }, /*#__PURE__*/ React.createElement("span", {
                        className: styles.username
                    }, username), /*#__PURE__*/ React.createElement(IncomingFriendRequestActionsCell, {
                        userId: row.userId,
                        username: row.username,
                        onAccept: onAccept,
                        onDecline: onDecline
                    }))
            }
        ], [
        onAccept,
        onDecline
    ]);
    const handleRowClick = useCallback((row)=>{
        onUserClick(row.userId, row.username);
    }, [
        onUserClick
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        testId: "profile-friend-requests-table",
        className: styles.container,
        data: requests,
        columns: columns,
        density: "comfortable",
        onRowClick: handleRowClick,
        emptyText: {
            key: 'strings:profilePage.friends.tabs.requests.defaultBody'
        },
        showEmptyText: requests.length == 0
    });
};
